const url = "/module/";

export default {
    getModules(axios){
        return axios.get(url)
            .then(response => {return {data: response.data}})
            .catch(error => {return {error: error?.response?.data}});
    }
}